import { render, staticRenderFns } from "./TaskCenterDetails.vue?vue&type=template&id=5a12b31c"
import script from "./TaskCenterDetails.vue?vue&type=script&lang=js"
export * from "./TaskCenterDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports